import { Navbar } from "flowbite-react";
import { DarkThemeToggle, Avatar } from "flowbite-react";
import { MdLogin } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";
import { UserContext } from "../utils/UserContext";
import { useContext } from "react";
import Logo from "./Logo";
import { GiExitDoor, GiEntryDoor } from "react-icons/gi";
import { Tooltip, IconButton } from "@mui/material";

export function NavbarComponent() {
  const { user, logout } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  console.log("Location", location);
  return (
    <Navbar fluid rounded>
      <Navbar.Brand>
        <Logo className="mr-3 h-6 sm:h-9" />
        <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
          Client Portal
        </span>
      </Navbar.Brand>
      <div className="flex md:order-2">
        <Tooltip title="Toggle dark mode">
          <IconButton>
            <DarkThemeToggle />
          </IconButton>
        </Tooltip>
        {sessionStorage.getItem("token") ? (
          <Tooltip title="Logout">
            <IconButton
              onClick={() => {
                logout();
                navigate("/login");
              }}
              className="bg-transparentfont-bold flex items-center rounded text-black dark:text-white"
            >
              <GiExitDoor />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Login">
            <button
              onClick={() => navigate("/login")}
              className="flex items-center rounded bg-transparent  px-4 py-2 font-bold text-black dark:text-white"
            >
              <GiEntryDoor />
            </button>
          </Tooltip>
        )}
        {/* <button
          onClick={() => navigate("/login")}
          className="flex items-center rounded bg-transparent  px-4 py-2 font-bold text-black dark:text-white"
        >
          <MdLogin />
        </button> */}
        <Navbar.Toggle />
      </div>
      <Navbar.Collapse>
        <Navbar.Link
          onClick={() => navigate("home")}
          active={pathname == "/home"}
        >
          Home
        </Navbar.Link>
        <Navbar.Link
          onClick={() => navigate("/projects")}
          active={pathname == "/projects"}
        >
          Projects
        </Navbar.Link>
        <Navbar.Link
          onClick={() => navigate("/environment")}
          active={pathname == "/environment"}
        >
          Environment
        </Navbar.Link>
        {user.role === "ADMIN" && (
          <Navbar.Link
            onClick={() => navigate("/users")}
            active={pathname == "/users"}
          >
            User Management
          </Navbar.Link>
        )}
        <Navbar.Link
          onClick={() => navigate("/FAQ")}
          active={pathname == "/FAQ"}
        >
          FAQ
        </Navbar.Link>
      </Navbar.Collapse>
    </Navbar>
  );
}
